import { Component, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import messages from '../assets/data/devextreme/locale.json';
import { locale, loadMessages } from 'devextreme/localization';

/* Services */
import { BaseService } from '../app/core/services/base.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'RMS | Aldawal';

  loadingScreen: boolean = true;

  constructor(
    private baseService: BaseService
  ) 
  {}

  ngOnInit(): void {
    loadMessages(messages);
    locale('ar');

    setTimeout(() => {
      this.loadingScreen = false;
    }, 3000);

    const expirationTime = localStorage.getItem('expirationTime');
    if (expirationTime) {
      const timeLeft = Number(expirationTime) - new Date().getTime();
      if (timeLeft > 0) {
        this.baseService.setLogoutTimer(timeLeft / 1000);
      } else {
        this.baseService.autoLogout();
      }
    }
  }

}
